import React, { useContext } from 'react';
import { connectSortBy } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import Dropdown from '@atoms/Dropdown';
import { sortOptionsByType } from '../../../data/sortOptions';
import { SearchTypeContext } from '../../../context/searchTypeContext';
import { SortByContext } from '../../../context/searchContext';

const SortByDropdownComponent = ({ onSortByChange }) => {
    const [searchType] = useContext(SearchTypeContext);
    const [sortBy, setSortBy] = useContext(SortByContext);

    return (
        <Dropdown
            options={sortOptionsByType[searchType.index] || []}
            selectedOption={sortBy}
            dropdownClasses="dropdown"
            dropdownItemClasses="dropdown-item my-3 pl-3"
            dropdownMenuClasses="dropdown-menu dropdown-menu-right m-0 mt-2 px-2 align-self-start"
            dropdownMenuLinkClasses="nav-link text-primary sort-list p-0"
            onOptionSelect={selectedOption => {
                setSortBy(selectedOption);
                onSortByChange(selectedOption);
            }}
        />
    );
};

SortByDropdownComponent.propTypes = {
    onSortByChange: PropTypes.func.isRequired,
};

const SortByDropdown = connectSortBy(SortByDropdownComponent);
export default SortByDropdown;
